function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "49.857%",
  y1: "-13.228%",
  x2: "49.857%",
  y2: "101.929%",
  id: "c"
}, React.createElement("stop", {
  stopColor: "#9527CC",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#4C00DD",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "49.244%",
  y1: "-905.18%",
  x2: "49.244%",
  y2: "1898.16%",
  id: "d"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "49.244%",
  y1: "-1811.31%",
  x2: "49.244%",
  y2: "992.035%",
  id: "e"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "50.955%",
  y1: "-1303.012%",
  x2: "50.955%",
  y2: "1390.389%",
  id: "f"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "50.568%",
  y1: "-852.862%",
  x2: "50.568%",
  y2: "4142.133%",
  id: "g"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "49.84%",
  y1: "-2551.131%",
  x2: "49.84%",
  y2: "2835.667%",
  id: "h"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "48.232%",
  y1: "-2762.894%",
  x2: "48.232%",
  y2: "2623.91%",
  id: "i"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "49.604%",
  y1: "-2634.521%",
  x2: "49.604%",
  y2: "417.99%",
  id: "j"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "50.7%",
  y1: "-2505.64%",
  x2: "50.7%",
  y2: "546.872%",
  id: "k"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "47.907%",
  y1: "-2634.521%",
  x2: "47.907%",
  y2: "417.99%",
  id: "l"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "49.518%",
  y1: "-2505.64%",
  x2: "49.518%",
  y2: "546.872%",
  id: "m"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "49.604%",
  y1: "-332.31%",
  x2: "49.604%",
  y2: "2720.222%",
  id: "n"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "50.7%",
  y1: "-461.193%",
  x2: "50.7%",
  y2: "2591.304%",
  id: "o"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "47.907%",
  y1: "-332.31%",
  x2: "47.907%",
  y2: "2720.222%",
  id: "p"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "49.518%",
  y1: "-461.193%",
  x2: "49.518%",
  y2: "2591.304%",
  id: "q"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "47.904%",
  y1: "-704.529%",
  x2: "47.904%",
  y2: "2347.983%",
  id: "r"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "47.904%",
  y1: "-31.198%",
  x2: "47.904%",
  y2: "3021.333%",
  id: "s"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "47.904%",
  y1: "-2262.303%",
  x2: "47.904%",
  y2: "790.209%",
  id: "t"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "47.904%",
  y1: "-2935.671%",
  x2: "47.904%",
  y2: "116.88%",
  id: "u"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "50.381%",
  y1: "-1038.333%",
  x2: "50.381%",
  y2: "3956.736%",
  id: "v"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "49.832%",
  y1: "-911.282%",
  x2: "49.832%",
  y2: "5193.744%",
  id: "w"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "50.191%",
  y1: "-1150.173%",
  x2: "50.191%",
  y2: "5093.627%",
  id: "x"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "48.53%",
  y1: "-4063.742%",
  x2: "48.53%",
  y2: "931.253%",
  id: "y"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "49.641%",
  y1: "-3878.267%",
  x2: "49.641%",
  y2: "1116.7%",
  id: "z"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "49.837%",
  y1: "-5120.162%",
  x2: "49.837%",
  y2: "984.864%",
  id: "A"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "50.191%",
  y1: "-5022.968%",
  x2: "50.191%",
  y2: "1220.902%",
  id: "B"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "C"
}, React.createElement("stop", {
  stopColor: "#891DCE",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#4F00D3",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "50.826%",
  y1: "-1811.31%",
  x2: "50.826%",
  y2: "992.035%",
  id: "D"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "49.975%",
  y1: "-1733.719%",
  x2: "49.975%",
  y2: "907.88%",
  id: "E"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "50.826%",
  y1: "-905.176%",
  x2: "50.826%",
  y2: "1898.141%",
  id: "F"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "49.142%",
  y1: "-820.261%",
  x2: "49.142%",
  y2: "1821.33%",
  id: "G"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "49.621%",
  y1: "-4768.171%",
  x2: "49.621%",
  y2: "5043.586%",
  id: "H"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "50.271%",
  y1: "-4550.314%",
  x2: "50.271%",
  y2: "5261.443%",
  id: "I"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "50.421%",
  y1: "-4332.45%",
  x2: "50.421%",
  y2: "5479.307%",
  id: "J"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "50.036%",
  y1: "-4111.021%",
  x2: "50.036%",
  y2: "5700.736%",
  id: "K"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "50.161%",
  y1: "-3893.021%",
  x2: "50.161%",
  y2: "5918.379%",
  id: "L"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "49.621%",
  y1: "-4989.604%",
  x2: "49.621%",
  y2: "4822.15%",
  id: "M"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "50.271%",
  y1: "-5207.454%",
  x2: "50.271%",
  y2: "4604.304%",
  id: "N"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "50.421%",
  y1: "-5428.889%",
  x2: "50.421%",
  y2: "4382.868%",
  id: "O"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "50.036%",
  y1: "-5646.75%",
  x2: "50.036%",
  y2: "4165.007%",
  id: "P"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "50.161%",
  y1: "-5867.968%",
  x2: "50.161%",
  y2: "3943.432%",
  id: "Q"
}, React.createElement("stop", {
  stopColor: "#FFD9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAF",
  offset: "54.66%"
}), React.createElement("stop", {
  stopColor: "#FF80FF",
  offset: "100%"
})), React.createElement("path", {
  id: "path-a",
  d: "M.737.281l78 71.47v17.496l-78 70.252z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "rotate(-90 347 91.5)"
}, React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#path-a"
})), React.createElement("g", {
  fillRule: "nonzero",
  mask: "url(#b)"
}, React.createElement("path", {
  d: "M112.431 342.865l13.464-13.073h98.343v3.513h-96.977l-10.732 10.731c13.269 57.756 53.464 106.731 107.709 130.926l-1.561 3.317c-55.61-24.78-96.782-75.121-110.05-134.438l-.196-.976zm25.757 13.074c14.244 42.73 45.464 78.828 85.855 99.316l-1.561 3.122c-41.562-21.073-73.562-58.341-88.001-102.438l-.39-.976 13.268-13.268h76.489v3.512H148.92l-10.732 10.732zm-25.561-96.78c13.268-59.317 54.44-109.658 110.44-134.438l1.366 3.317c-54.44 24.195-94.635 73.17-107.904 131.12l10.732 10.733h96.782v3.512H125.7l-13.269-13.268.196-.976zm110.05-114.536l1.561 3.122c-40.39 20.293-71.806 56.585-86.05 99.316l10.732 10.732h74.733v3.512h-76.294l-13.269-13.268.39-.976c14.44-44.097 46.635-81.56 88.197-102.438zM172.92 357.304l-10.537 10.732c6.44 13.268 14.635 25.56 24.586 36.683l-.78 4.487c-11.318-12.097-20.684-25.756-27.708-40.78l-.585-1.17 13.463-13.464h52.489v3.512H172.92zm-45.854 93.463c-31.806-37.073-50.538-82.536-54.44-131.12v-.781l13.073-13.073h138.149v3.512H87.065l-10.927 10.927c8 96.389 75.709 176.583 169.174 200.388v-60.487h3.512v64.975l-2.147-.586c-46.634-11.512-88.001-37.072-119.611-73.755zM91.943 330.768l13.074-12.683h118.83v3.512h-117.27L95.847 332.33c11.317 76.097 65.172 140.877 137.758 166.047v-54.438c-15.22-7.415-29.074-17.17-41.366-28.878h5.268c11.512 10.536 24.39 19.317 38.635 25.951l.975.39v61.658l-2.341-.78c-36.879-12.293-69.855-34.537-95.026-64.585-25.561-30.244-41.952-66.926-47.61-105.95l-.196-.976zm66.148-94.828l.78-.976c6.83-14.439 15.805-27.902 26.732-39.805v5.269c-9.366 10.536-16.976 22.243-23.024 34.926l10.536 10.537h50.733v3.512h-52.294l-13.463-13.463zm332.298 22.634l11.122 11.121h98.343v3.513h-99.71l-12.877-12.878-.196-.586c-15.805-70.243-71.22-126.438-141.27-143.218l.78-3.512c71.221 16.975 127.612 74.146 143.808 145.56zM296.434 459.938h3.317v103.608h1.561c115.71 0 216.199-74.145 250.346-184.583l3.512.975c-16.39 53.073-49.952 100.682-94.636 134.243-46.05 34.536-101.074 52.878-159.026 52.878h-5.074V459.938zM112.822 141.306C150.48 97.014 202.384 67.356 258.97 57.6l2.147-.39v85.852h-3.513v-81.56C141.7 82.575 57.601 183.062 57.601 301.5c0 118.438 83.904 218.925 200.199 239.998v-81.56h3.512v85.853l-2.147-.39c-56.781-9.757-108.88-39.61-146.343-83.707C74.772 417.206 53.894 360.23 53.894 301.5c0-58.536 20.878-115.511 58.928-160.194zM282.97 437.694h3.512v127.413h-3.512V437.694zM474.388 270.67l11.122 11.122h115.124v3.512H483.95l-12.878-12.878-.195-.585c-11.317-65.756-60.684-119.414-125.27-136.584l.975-3.513c65.758 17.366 115.905 72 127.807 138.926zM282.971 37.697h3.512v127.414h-3.512V37.697zm-143.222 127.61c25.171-30.05 58.147-52.488 95.026-64.195l2.341-.78v61.657l-.975.39c-14.05 6.634-26.928 15.22-38.44 25.756h-5.268c12.293-11.707 25.951-21.268 41.171-28.487v-54.439c-72.782 25.17-126.636 89.95-137.953 166.047l10.732 10.732h117.27v3.512H105.017l-13.074-13.073.195-.976c5.659-39.219 22.05-75.901 47.61-106.145zm-12.488-13.27c31.61-36.682 72.977-62.242 119.807-73.56l2.146-.585v65.17h-3.512V82.38c-93.66 23.805-161.564 104-169.369 200.388l10.927 10.927h136.588v3.512H85.699l-13.073-13.073v-.78c3.902-48.78 22.83-94.243 54.635-131.316zm359.81 190.438l12.879-12.878h99.709v3.512h-98.343l-11.123 11.122c-16.195 71.414-72.586 128.585-143.807 145.56l-.78-3.512c70.05-16.585 125.66-72.975 141.27-143.218l.195-.586zm37.27 17.756l6.438-6.439h65.562v3.512h-64l-11.123 11.122c-13.268 43.317-38.83 81.56-73.952 110.438-35.708 29.463-78.83 47.22-124.88 51.317l-1.951.195v-70.438h3.512v66.536c91.318-8.976 167.417-71.414 193.954-159.414.78-1.17 2.537-2.926 6.44-6.829zm8.78 18.341l12.683-12.877h50.342c-14.634 65.56-52.293 127.413-104.977 170.144-53.464 43.317-120.782 67.122-189.661 67.122C135.26 602.96.039 468.328.039 302.085.04 135.843 135.261.625 301.508.625c68.879 0 136.197 23.804 189.661 67.121 52.684 42.536 90.148 104.39 104.977 170.145H546l-12.878-12.878-.195-.39c-32-95.61-120.587-162.145-221.077-166.438v85.268h-3.512V54.478h1.951c51.318 1.756 99.904 19.122 140.685 49.95 39.806 30.244 69.465 71.22 85.27 118.439l11.122 11.121h44.489C560.829 100.331 439.07 3.747 301.703 3.747 137.407 3.747 3.747 137.404 3.747 301.695c0 164.291 133.66 297.949 297.956 297.949 137.368 0 259.126-96.78 290.15-230.242H547.56l-11.122 11.122c-15.805 47.219-45.269 88.194-85.27 118.438-40.78 30.829-89.562 48.194-140.685 49.95h-1.951v-88.974h3.512v85.267c100.49-4.097 189.272-71.219 221.077-166.633zM517.9 236.135C491.364 147.94 415.265 85.697 324.142 76.722v66.34h-3.512V72.82l1.951.195c45.854 4.098 89.172 21.854 124.88 51.317 35.318 28.878 60.684 67.121 73.952 110.438l11.123 11.122h64v3.512h-65.561l-12.879-12.878-.195-.39zm-77.855 47.024c.39 3.902.78 8.195.976 12.292l-3.512.195c-.195-4.097-.39-8.195-.976-12.097-7.61-57.95-52.684-104.975-109.855-115.706v-3.708c58.927 10.732 105.562 59.317 113.367 119.024zm29.074 10.536h132.1v3.512H467.559L454.68 284.33v-.585c-7.61-65.755-56.196-119.023-120.783-132.877l-1.366-.39V92.136l2.147.39c82.538 12.878 149.856 73.365 171.515 154.145l11.122 11.122h81.172v3.512h-82.733l-12.878-12.878-.196-.39c-20.878-78.829-86.245-138.145-166.636-151.608v51.316c65.367 14.44 114.343 68.487 122.148 135.023l10.927 10.927zm-14.44 24.976l12.879-12.878h133.66v3.512h-132.1l-10.926 10.927c-8 66.34-56.781 120.584-122.148 135.023v51.316c80.391-13.268 145.758-72.584 166.636-151.608l.196-.39 12.878-12.878h82.733v3.512h-81.172l-11.122 11.122c-21.66 80.78-88.977 141.267-171.515 154.145l-2.147.39v-58.341l1.366-.39c64.782-13.854 113.173-67.122 120.783-132.877v-.585zm16.391 11.902l12.878-12.878h116.685v3.512H485.51l-11.122 11.122c-11.902 66.926-62.05 121.56-127.807 138.926l-.975-3.513c64.586-17.17 113.758-70.633 125.27-136.584l.195-.585zM271.263 37.697l1.951-.195v105.56h-3.512V41.405C138.383 57.405 39.65 168.818 39.65 301.5c0 132.682 98.733 244.095 230.052 259.9V459.938h3.512v105.56l-1.95-.195C137.016 550.083 35.941 436.718 35.941 301.5S137.212 52.917 271.263 37.697zm300.688 178.34l-3.512 1.171C531.559 100.136 424.24 21.502 301.508 21.502c-154.344 0-279.81 125.463-279.81 279.803s125.66 279.997 280.005 279.997c121.758 0 228.881-77.853 266.345-193.754l3.317 1.17c-18.341 56.586-53.464 105.366-101.465 140.878-48.976 36.292-107.318 55.414-168.392 55.414C145.212 585.01 17.99 457.79 17.99 301.5S145.212 17.99 301.508 17.99c61.464 0 120.001 19.317 169.173 56 47.61 35.317 83.513 85.853 101.27 142.047zm-131.905 103.61c-7.805 59.51-54.05 108.29-112.782 119.218v-3.708c56.977-10.926 101.66-58.145 109.27-115.901.39-3.902.78-8 .976-11.902l3.512.195c-.195 4.097-.39 8.195-.976 12.097zm111.807-95.61C517.706 113.794 417.217 39.65 301.703 39.454h-1.561v103.413h-3.513V35.941h5.074c57.757 0 112.782 18.342 159.027 52.878 44.683 33.56 78.245 81.17 94.635 134.243l-3.512.975z",
  transform: "matrix(-1 0 0 1 248 -222)",
  fill: "url(#c)"
}), React.createElement("path", {
  d: "M35.513 187.355l-5.074-1.561 2.927-8.78c.976-2.928 2.147-5.854 3.122-8.781l5.074 1.951c-1.171 2.732-2.147 5.659-3.122 8.585-1.171 2.732-2.147 5.659-2.927 8.586z",
  fill: "url(#d)",
  transform: "matrix(-1 0 0 1 231.375 -184.927)"
}), React.createElement("path", {
  d: "M36.488 360.621c-1.17-2.926-2.146-5.853-3.122-8.78-.975-2.927-1.95-5.854-2.927-8.78l5.074-1.561c.975 2.926 1.756 5.853 2.927 8.585.975 2.927 2.146 5.658 3.122 8.585l-5.074 1.951z",
  fill: "url(#e)",
  transform: "matrix(-1 0 0 1 231.375 -184.927)"
}), React.createElement("path", {
  d: "M.585 274.378c-.195-3.317-.195-6.634-.195-9.95 0-3.318 0-6.635.195-9.952l5.464.195c-.195 3.317-.195 6.44-.195 9.756 0 3.317 0 6.44.195 9.756l-5.464.195z",
  fill: "url(#f)",
  transform: "matrix(-1 0 0 1 231.375 -184.927)"
}), React.createElement("path", {
  d: "M196.1 97.404l-2.536-4.683c1.951-.975 4.098-2.146 6.049-3.122 1.951-.975 4.097-1.95 6.049-2.926l2.146 4.878c-1.951.975-4.098 1.756-6.049 2.731-1.756 1.171-3.707 2.147-5.658 3.122z",
  fill: "url(#g)",
  transform: "matrix(-1 0 0 1 231.375 -184.927)"
}), React.createElement("path", {
  d: "M419.909 258.964c0-1.561-.195-3.122-.195-4.683-.195-1.561-.195-3.122-.39-4.683l5.268-.585c.195 1.56.39 3.317.39 4.878.195 1.56.195 3.317.195 4.878l-5.268.195z",
  fill: "url(#h)",
  transform: "matrix(-1 0 0 1 231.375 -184.927)"
}), React.createElement("path", {
  d: "M424.592 280.037l-5.268-.586c.195-1.56.39-3.122.39-4.682.195-1.561.195-3.122.195-4.683l5.463.195c0 1.56-.195 3.317-.195 4.878-.39 1.56-.39 3.122-.585 4.878z",
  fill: "url(#i)",
  transform: "matrix(-1 0 0 1 231.375 -184.927)"
}), React.createElement("path", {
  fill: "url(#j)",
  d: "M240.004 457.791h5.463v17.561h-5.463z",
  transform: "matrix(-1 0 0 1 231.375 -184.927)"
}), React.createElement("path", {
  fill: "url(#k)",
  d: "M227.906 435.157h5.463v17.561h-5.463z",
  transform: "matrix(-1 0 0 1 231.375 -184.927)"
}), React.createElement("path", {
  fill: "url(#l)",
  d: "M290.931 457.791h5.463v17.561h-5.463z",
  transform: "matrix(-1 0 0 1 231.375 -184.927)"
}), React.createElement("path", {
  fill: "url(#m)",
  d: "M302.834 435.157h5.463v17.561h-5.463z",
  transform: "matrix(-1 0 0 1 231.375 -184.927)"
}), React.createElement("path", {
  fill: "url(#n)",
  d: "M240.004 53.502h5.463v17.561h-5.463z",
  transform: "matrix(-1 0 0 1 231.375 -184.927)"
}), React.createElement("path", {
  fill: "url(#o)",
  d: "M227.906 76.136h5.463v17.561h-5.463z",
  transform: "matrix(-1 0 0 1 231.375 -184.927)"
}), React.createElement("path", {
  fill: "url(#p)",
  d: "M290.931 53.502h5.463v17.561h-5.463z",
  transform: "matrix(-1 0 0 1 231.375 -184.927)"
}), React.createElement("path", {
  fill: "url(#q)",
  d: "M302.834 76.136h5.463v17.561h-5.463z",
  transform: "matrix(-1 0 0 1 231.375 -184.927)"
}), React.createElement("path", {
  fill: "url(#r)",
  d: "M265.565 118.867h5.463v17.561h-5.463z",
  transform: "matrix(-1 0 0 1 231.375 -184.927)"
}), React.createElement("path", {
  fill: "url(#s)",
  d: "M265.565.625h5.463v17.561h-5.463z",
  transform: "matrix(-1 0 0 1 231.375 -184.927)"
}), React.createElement("path", {
  fill: "url(#t)",
  d: "M265.565 392.426h5.463v17.561h-5.463z",
  transform: "matrix(-1 0 0 1 231.375 -184.927)"
}), React.createElement("path", {
  fill: "url(#u)",
  d: "M265.565 510.669h5.463v17.561h-5.463z",
  transform: "matrix(-1 0 0 1 231.375 -184.927)"
}), React.createElement("path", {
  d: "M197.662 117.307l-2.732-4.683c1.756-.976 3.512-2.147 5.268-3.122 1.756-.976 3.708-1.951 5.464-2.927l2.341 4.878c-1.756.976-3.512 1.756-5.268 2.732-1.561 1.17-3.317 2.146-5.073 3.122z",
  fill: "url(#v)",
  transform: "matrix(-1 0 0 1 231.375 -184.927)"
}), React.createElement("path", {
  d: "M341.469 83.941c-2.147-.585-4.293-1.366-6.244-1.951-2.147-.586-4.293-1.171-6.44-1.561l1.171-5.268c2.147.585 4.293 1.17 6.635 1.756 2.146.585 4.292 1.17 6.439 1.95l-1.561 5.074z",
  fill: "url(#w)",
  transform: "matrix(-1 0 0 1 231.375 -184.927)"
}), React.createElement("path", {
  d: "M339.713 102.477c-1.952-.585-3.708-1.17-5.659-1.756-1.951-.585-3.903-1.17-5.659-1.56l1.366-5.269 5.854 1.756c1.951.586 3.902 1.17 5.854 1.951l-1.756 4.878z",
  fill: "url(#x)",
  transform: "matrix(-1 0 0 1 231.375 -184.927)"
}), React.createElement("path", {
  d: "M196.1 97.404l-2.536-4.683c1.951-.975 4.098-2.146 6.049-3.122 1.951-.975 4.097-1.95 6.049-2.926l2.146 4.878c-1.951.975-4.098 1.756-6.049 2.731-1.756 1.171-3.707 2.147-5.658 3.122z",
  fill: "url(#g)",
  transform: "matrix(-1 0 0 1 231.375 -184.927)"
}), React.createElement("path", {
  d: "M197.662 117.307l-2.732-4.683c1.756-.976 3.512-2.147 5.268-3.122 1.756-.976 3.708-1.951 5.464-2.927l2.341 4.878c-1.756.976-3.512 1.756-5.268 2.732-1.561 1.17-3.317 2.146-5.073 3.122z",
  fill: "url(#v)",
  transform: "matrix(-1 0 0 1 231.375 -184.927)"
}), React.createElement("path", {
  d: "M341.469 83.941c-2.147-.585-4.293-1.366-6.244-1.951-2.147-.586-4.293-1.171-6.44-1.561l1.171-5.268c2.147.585 4.293 1.17 6.635 1.756 2.146.585 4.292 1.17 6.439 1.95l-1.561 5.074z",
  fill: "url(#w)",
  transform: "matrix(-1 0 0 1 231.375 -184.927)"
}), React.createElement("path", {
  d: "M339.713 102.477c-1.952-.585-3.708-1.17-5.659-1.756-1.951-.585-3.903-1.17-5.659-1.56l1.366-5.269 5.854 1.756c1.951.586 3.902 1.17 5.854 1.951l-1.756 4.878z",
  fill: "url(#x)",
  transform: "matrix(-1 0 0 1 231.375 -184.927)"
}), React.createElement("path", {
  d: "M205.857 441.987c-2.147-.976-4.098-1.952-6.049-2.927-1.951-.976-4.098-1.951-6.049-3.122l2.537-4.683 5.853 2.927c1.952.975 3.903 1.95 6.05 2.731l-2.342 5.074z",
  fill: "url(#y)",
  transform: "matrix(-1 0 0 1 231.375 -184.927)"
}), React.createElement("path", {
  d: "M205.662 422.084c-1.756-.975-3.708-1.95-5.464-2.927-1.756-.975-3.512-1.95-5.268-3.121l2.732-4.683 5.268 2.926c1.756.976 3.512 1.952 5.268 2.732l-2.536 5.073z",
  fill: "url(#z)",
  transform: "matrix(-1 0 0 1 231.375 -184.927)"
}), React.createElement("path", {
  d: "M329.956 453.499l-1.17-5.269c2.146-.585 4.292-.975 6.439-1.56 2.146-.586 4.292-1.171 6.244-1.952l1.56 5.073c-2.146.586-4.292 1.366-6.438 1.952-2.147.78-4.488 1.365-6.635 1.756z",
  fill: "url(#A)",
  transform: "matrix(-1 0 0 1 231.375 -184.927)"
}), React.createElement("path", {
  d: "M329.761 434.962l-1.366-5.268c1.952-.585 3.903-.976 5.659-1.561 1.951-.585 3.707-1.17 5.659-1.756l1.756 5.073c-1.952.585-3.903 1.366-5.854 1.951-1.951.586-3.903 1.171-5.854 1.561z",
  fill: "url(#B)",
  transform: "matrix(-1 0 0 1 231.375 -184.927)"
}))), React.createElement("path", {
  id: "circle-logo",
  d: "M249.58 416.002l-1.213 1.238 1.778 1.742.041-.041 1.36-2.027-1.723-1.157-.243.245zm6.703.303l-5.798 5.919-.022-.015-.34.342-1.774-1.8a27.309 27.309 0 01-7.791-20.948c.381-6.61 3.095-12.881 7.789-17.677l39.122-39.953a9.244 9.244 0 002.2-3.64 9.336 9.336 0 00-2.364-8.898l-38.476-39.003c-10.449-10.592-10.464-27.77-.034-38.384l1.78-1.811 57.443 58.235c14.96 15.168 14.98 39.76.047 54.953l-51.782 52.68zm145.174-159.351l1.173-1.198-1.778-1.741-1.764 1.742a22.146 22.146 0 011.672 1.898l.697-.701zm8.955 16.644a27.463 27.463 0 01-7.762 17.272l-39.122 39.953a9.282 9.282 0 00-2.193 3.61 9.333 9.333 0 002.356 8.925l38.48 39.01c10.452 10.592 10.467 27.77.033 38.385l-1.78 1.81-1.782-1.807-55.664-56.428c-14.958-15.167-14.977-39.76-.043-54.953l51.456-52.351 6.83-6.976 1.511 2.283a27.291 27.291 0 017.68 21.267zm-139.224 54.223a12.747 12.747 0 013.273 12.253 12.664 12.664 0 01-8.92 8.989 12.581 12.581 0 01-12.212-3.283c-4.927-4.954-4.933-12.985-.013-17.946a12.58 12.58 0 0117.872-.013zm110.052 17.96c-4.928-4.955-4.934-12.987-.014-17.949a12.581 12.581 0 0117.873-.015 12.748 12.748 0 013.274 12.254 12.665 12.665 0 01-8.92 8.99 12.583 12.583 0 01-12.213-3.28z",
  stroke: "url(#C)",
  strokeWidth: 5,
  transform: "translate(10.5 9.5)"
}), React.createElement("g", {
  fillRule: "nonzero"
}, React.createElement("g", null, React.createElement("g", {
  opacity: 0.605,
  fill: "#5C5C5C"
}, React.createElement("path", {
  d: "M.39 337.841v-4.681h9.168v4.681zM26.77 465.807l-1.791-4.326 8.47-3.508 1.792 4.325zM100.29 574.008l-3.31-3.31 6.482-6.483 3.31 3.31zM209.344 645.945l-4.325-1.792 3.508-8.47 4.325 1.792zM333.159 670.61v-9.168h4.681v9.168zM461.671 645.916l-3.508-8.47 4.325-1.792 3.508 8.47zM570.726 574.035l-6.482-6.483 3.31-3.31 6.482 6.483zM644.27 465.813l-8.47-3.51 1.793-4.324 8.469 3.51zM661.442 337.841v-4.681h9.168v4.681zM637.496 212.791l-1.791-4.325 8.47-3.509 1.791 4.326zM567.704 106.664l-3.31-3.31 6.482-6.483 3.31 3.31zM462.25 35.203l-4.325-1.791 3.508-8.47 4.325 1.791zM333.159 9.558V.39h4.681v9.168zM208.667 35.28l-3.51-8.47 4.325-1.791 3.51 8.469zM103.35 106.642l-6.482-6.483 3.31-3.31 6.483 6.483zM33.504 212.825l-8.47-3.509 1.791-4.325 8.47 3.509z"
})), React.createElement("g", {
  opacity: 0.605,
  fill: "#5C5C5C"
}, React.createElement("path", {
  d: "M2.05 353.803l-.182-3.701 6.82-.335.181 3.701zM3.331 370.146l-.363-3.689 6.794-.669.363 3.689zM5.592 386.275l-.544-3.666 6.754-1.002.543 3.666zM8.39 402.422l-.723-3.635 6.696-1.332.723 3.635zM12.065 418.416l-.9-3.595 6.621-1.66.901 3.596zM16.49 434.176l-1.075-3.547 6.533-1.982 1.076 3.547zM21.678 449.727l-1.249-3.49 6.428-2.3 1.248 3.49zM34.448 479.917l-1.584-3.35 6.171-2.92 1.585 3.35zM41.793 494.545l-1.747-3.268 6.021-3.219 1.747 3.269zM50.04 508.828l-1.906-3.179 5.855-3.51 1.906 3.178zM58.986 522.552l-2.058-3.082 5.676-3.792 2.059 3.081zM68.524 535.855l-2.208-2.977 5.485-4.067 2.207 2.977zM78.555 548.676l-2.35-2.865 5.277-4.331 2.35 2.865zM89.32 561.059l-2.49-2.746 5.06-4.585 2.488 2.747zM112.668 584.126l-2.747-2.488 4.585-5.06 2.746 2.49zM125.107 594.71l-2.865-2.352 4.33-5.277 2.866 2.35zM137.955 604.789l-2.977-2.208 4.066-5.484 2.977 2.208zM151.45 614.181l-3.082-2.058 3.792-5.677 3.082 2.059zM165.507 622.813l-3.178-1.905 3.51-5.856 3.178 1.905zM179.838 630.824l-3.268-1.747 3.218-6.02 3.269 1.746zM194.372 638.115l-3.35-1.585 2.919-6.172 3.35 1.585zM224.848 650.482l-3.489-1.249 2.3-6.427 3.49 1.248zM240.38 655.551l-3.546-1.076 1.982-6.532 3.546 1.075zM256.167 659.835l-3.595-.9 1.659-6.623 3.595.901zM272.115 663.321l-3.635-.723 1.332-6.696 3.635.723zM288.22 666.031l-3.666-.543 1.002-6.754 3.666.544zM304.676 667.87l-3.688-.363.669-6.794 3.688.363zM320.998 669.169l-3.702-.182.335-6.82 3.702.183zM350.1 669.139l-.334-6.82 3.702-.18.333 6.819zM366.459 668.05l-.667-6.794 3.689-.362.666 6.794zM382.587 665.958l-1-6.753 3.666-.543 1 6.753zM398.798 663.322l-1.331-6.696 3.635-.722 1.33 6.696zM414.777 659.814l-1.658-6.623 3.595-.9 1.658 6.623zM430.57 655.592l-1.98-6.533 3.547-1.075 1.98 6.533zM446.215 650.617l-2.3-6.427 3.489-1.249 2.3 6.428zM476.605 638.073l-2.916-6.173 3.35-1.583 2.917 6.173zM491.256 630.875l-3.22-6.02 3.268-1.748 3.22 6.02zM505.685 622.862l-3.512-5.855 3.179-1.906 3.511 5.855zM519.496 614.12l-3.794-5.676 3.08-2.06 3.795 5.675zM532.892 604.678l-4.065-5.485 2.977-2.207 4.066 5.485zM545.817 594.845l-4.329-5.279 2.866-2.35 4.329 5.279zM558.387 584.205l-4.583-5.06 2.747-2.488 4.583 5.06zM581.64 561.067l-5.058-4.585 2.49-2.745 5.058 4.585zM592.34 548.79l-5.276-4.333 2.352-2.864 5.276 4.332zM602.588 535.989l-5.484-4.067 2.208-2.977 5.483 4.067zM612.095 522.57l-5.677-3.793 2.06-3.082 5.676 3.793zM620.863 508.697l-5.853-3.513 1.907-3.177 5.853 3.513zM629.09 494.437l-6.02-3.22 1.749-3.268 6.02 3.22zM636.583 479.937l-6.171-2.92 1.585-3.35 6.171 2.92zM649.208 449.739l-6.427-2.3 1.248-3.49 6.428 2.3zM654.433 434.2l-6.533-1.98 1.075-3.547 6.533 1.98zM658.92 418.433l-6.623-1.66.901-3.594 6.622 1.66zM662.681 402.533l-6.695-1.334.724-3.634 6.695 1.333zM665.57 386.205l-6.754-1 .543-3.666 6.753 1zM667.537 370.02l-6.795-.667.362-3.688 6.795.666zM669 353.708l-6.82-.333.181-3.701 6.819.333zM662.311 321.232l-.181-3.702 6.819-.334.181 3.702zM661.246 305.19l-.363-3.688 6.794-.668.363 3.688zM659.368 289.313l-.544-3.666 6.754-1.001.543 3.666zM656.574 273.515l-.723-3.635 6.696-1.331.723 3.635zM653.201 257.927l-.9-3.595 6.622-1.658.9 3.595zM649.164 242.37l-1.076-3.547 6.534-1.981 1.075 3.546zM644.2 227.133l-1.249-3.49 6.429-2.299 1.248 3.49zM631.958 197.356l-1.585-3.35 6.172-2.92 1.584 3.351zM624.947 182.93l-1.748-3.27 6.02-3.218 1.748 3.268zM616.991 168.93l-1.905-3.179 5.855-3.51 1.905 3.178zM608.49 155.31l-2.06-3.082 5.676-3.794 2.06 3.082zM599.365 142.028l-2.208-2.977 5.484-4.066 2.208 2.977zM589.53 129.527l-2.35-2.865 5.277-4.331 2.35 2.865zM579.242 117.25l-2.489-2.745 5.059-4.585 2.489 2.746zM556.385 94.464l-2.746-2.489 4.584-5.059 2.746 2.489zM544.532 83.785l-2.865-2.35 4.331-5.278 2.865 2.351zM531.964 73.865l-2.977-2.207 4.066-5.484 2.977 2.207zM518.85 64.675l-3.08-2.06 3.794-5.675 3.08 2.06zM505.208 55.792l-3.178-1.905 3.51-5.856 3.179 1.906zM491.196 47.918l-3.268-1.747 3.219-6.02 3.268 1.747zM477.048 40.648l-3.35-1.585 2.918-6.171 3.35 1.584zM447.343 28.263l-3.49-1.248 2.299-6.428 3.49 1.248zM432.089 23.123l-3.547-1.075 1.982-6.534 3.546 1.076zM416.837 18.752l-3.595-.9 1.658-6.622 3.595.9zM401.204 15.063l-3.635-.723 1.331-6.696 3.635.723zM385.256 12.183l-3.666-.543 1-6.753 3.667.543zM369.35 10.084l-3.688-.363.668-6.794 3.688.363zM353.368 8.83l-3.702-.18.335-6.82 3.701.182zM317.522 8.878l-.333-6.82 3.702-.18.333 6.819zM301.498 10.143l-.667-6.794 3.688-.362.667 6.794zM285.617 12.132l-1-6.753 3.666-.543 1 6.753zM269.868 15.034l-1.333-6.696 3.635-.723 1.333 6.695zM254.332 18.682l-1.66-6.622 3.596-.9 1.66 6.622zM238.846 23.035l-1.98-6.533 3.547-1.075 1.98 6.533zM223.547 28.112l-2.301-6.428 3.49-1.249 2.3 6.428zM193.935 40.623l-2.92-6.171 3.35-1.586 2.92 6.171zM179.675 47.81l-3.22-6.02 3.268-1.748 3.22 6.02zM165.73 55.932l-3.514-5.853 3.178-1.907 3.513 5.853zM152.232 64.584l-3.793-5.677 3.081-2.06 3.794 5.677zM139.063 73.829l-4.067-5.484 2.977-2.207 4.066 5.483zM126.677 83.863l-4.333-5.275 2.864-2.352 4.333 5.276zM114.465 94.278l-4.585-5.058 2.746-2.49 4.585 5.059zM91.995 117.237l-5.06-4.584 2.489-2.746 5.06 4.583zM81.436 129.372l-5.28-4.329 2.35-2.865 5.28 4.329zM71.687 142.11l-5.485-4.065 2.207-2.978 5.485 4.065zM62.5 155.201l-5.676-3.795 2.06-3.08 5.676 3.795zM53.958 168.888l-5.855-3.51 1.906-3.179 5.855 3.511zM46.156 182.969l-6.02-3.22 1.748-3.268 6.02 3.22zM38.992 197.269l-6.173-2.917 1.583-3.35 6.173 2.916zM26.974 227.164l-6.428-2.3 1.249-3.49 6.428 2.3zM22.037 242.396l-6.533-1.98 1.074-3.546 6.534 1.98zM17.806 257.77l-6.623-1.658.9-3.595 6.623 1.657zM14.383 273.465l-6.696-1.33.722-3.635 6.696 1.33zM11.75 289.205l-6.754-1 .543-3.666 6.753 1zM9.74 305.34l-6.794-.668.362-3.688 6.795.667zM8.656 321.336l-6.819-.333.181-3.702 6.819.334z"
})), React.createElement("g", {
  fill: "#FFF",
  id: "outer-circles"
}, React.createElement("path", {
  d: "M.39 337.841v-4.681h9.168v4.681zM26.77 465.807l-1.791-4.326 8.47-3.508 1.792 4.325zM100.29 574.008l-3.31-3.31 6.482-6.483 3.31 3.31zM209.344 645.945l-4.325-1.792 3.508-8.47 4.325 1.792zM333.159 670.61v-9.168h4.681v9.168zM461.671 645.916l-3.508-8.47 4.325-1.792 3.508 8.47zM570.726 574.035l-6.482-6.483 3.31-3.31 6.482 6.483zM644.27 465.813l-8.47-3.51 1.793-4.324 8.469 3.51zM661.442 337.841v-4.681h9.168v4.681zM637.496 212.791l-1.791-4.325 8.47-3.509 1.791 4.326zM567.704 106.664l-3.31-3.31 6.482-6.483 3.31 3.31zM462.25 35.203l-4.325-1.791 3.508-8.47 4.325 1.791zM333.159 9.558V.39h4.681v9.168zM208.667 35.28l-3.51-8.47 4.325-1.791 3.51 8.469zM103.35 106.642l-6.482-6.483 3.31-3.31 6.483 6.483zM33.504 212.825l-8.47-3.509 1.791-4.325 8.47 3.509z"
}))), React.createElement("path", {
  d: "M112.431 342.865l13.464-13.073h98.343v3.513h-96.977l-10.732 10.731c13.269 57.756 53.464 106.731 107.709 130.926l-1.561 3.317c-55.61-24.78-96.782-75.121-110.05-134.438l-.196-.976zm25.757 13.074c14.244 42.73 45.464 78.828 85.855 99.316l-1.561 3.122c-41.562-21.073-73.562-58.341-88.001-102.438l-.39-.976 13.268-13.268h76.489v3.512H148.92l-10.732 10.732zm-25.561-96.78c13.268-59.317 54.44-109.658 110.44-134.438l1.366 3.317c-54.44 24.195-94.635 73.17-107.904 131.12l10.732 10.733h96.782v3.512H125.7l-13.269-13.268.196-.976zm110.05-114.536l1.561 3.122c-40.39 20.293-71.806 56.585-86.05 99.316l10.732 10.732h74.733v3.512h-76.294l-13.269-13.268.39-.976c14.44-44.097 46.635-81.56 88.197-102.438zM172.92 357.304l-10.537 10.732c6.44 13.268 14.635 25.56 24.586 36.683l-.78 4.487c-11.318-12.097-20.684-25.756-27.708-40.78l-.585-1.17 13.463-13.464h52.489v3.512H172.92zm-45.854 93.463c-31.806-37.073-50.538-82.536-54.44-131.12v-.781l13.073-13.073h138.149v3.512H87.065l-10.927 10.927c8 96.389 75.709 176.583 169.174 200.388v-60.487h3.512v64.975l-2.147-.586c-46.634-11.512-88.001-37.072-119.611-73.755zM91.943 330.768l13.074-12.683h118.83v3.512h-117.27L95.847 332.33c11.317 76.097 65.172 140.877 137.758 166.047v-54.438c-15.22-7.415-29.074-17.17-41.366-28.878h5.268c11.512 10.536 24.39 19.317 38.635 25.951l.975.39v61.658l-2.341-.78c-36.879-12.293-69.855-34.537-95.026-64.585-25.561-30.244-41.952-66.926-47.61-105.95l-.196-.976zm66.148-94.828l.78-.976c6.83-14.439 15.805-27.902 26.732-39.805v5.269c-9.366 10.536-16.976 22.243-23.024 34.926l10.536 10.537h50.733v3.512h-52.294l-13.463-13.463zm332.298 22.634l11.122 11.121h98.343v3.513h-99.71l-12.877-12.878-.196-.586c-15.805-70.243-71.22-126.438-141.27-143.218l.78-3.512c71.221 16.975 127.612 74.146 143.808 145.56zM296.434 459.938h3.317v103.608h1.561c115.71 0 216.199-74.145 250.346-184.583l3.512.975c-16.39 53.073-49.952 100.682-94.636 134.243-46.05 34.536-101.074 52.878-159.026 52.878h-5.074V459.938zM112.822 141.306C150.48 97.014 202.384 67.356 258.97 57.6l2.147-.39v85.852h-3.513v-81.56C141.7 82.575 57.601 183.062 57.601 301.5c0 118.438 83.904 218.925 200.199 239.998v-81.56h3.512v85.853l-2.147-.39c-56.781-9.757-108.88-39.61-146.343-83.707C74.772 417.206 53.894 360.23 53.894 301.5c0-58.536 20.878-115.511 58.928-160.194zM282.97 437.694h3.512v127.413h-3.512V437.694zM474.388 270.67l11.122 11.122h115.124v3.512H483.95l-12.878-12.878-.195-.585c-11.317-65.756-60.684-119.414-125.27-136.584l.975-3.513c65.758 17.366 115.905 72 127.807 138.926zM282.971 37.697h3.512v127.414h-3.512V37.697zm-143.222 127.61c25.171-30.05 58.147-52.488 95.026-64.195l2.341-.78v61.657l-.975.39c-14.05 6.634-26.928 15.22-38.44 25.756h-5.268c12.293-11.707 25.951-21.268 41.171-28.487v-54.439c-72.782 25.17-126.636 89.95-137.953 166.047l10.732 10.732h117.27v3.512H105.017l-13.074-13.073.195-.976c5.659-39.219 22.05-75.901 47.61-106.145zm-12.488-13.27c31.61-36.682 72.977-62.242 119.807-73.56l2.146-.585v65.17h-3.512V82.38c-93.66 23.805-161.564 104-169.369 200.388l10.927 10.927h136.588v3.512H85.699l-13.073-13.073v-.78c3.902-48.78 22.83-94.243 54.635-131.316zm359.81 190.438l12.879-12.878h99.709v3.512h-98.343l-11.123 11.122c-16.195 71.414-72.586 128.585-143.807 145.56l-.78-3.512c70.05-16.585 125.66-72.975 141.27-143.218l.195-.586zm37.27 17.756l6.438-6.439h65.562v3.512h-64l-11.123 11.122c-13.268 43.317-38.83 81.56-73.952 110.438-35.708 29.463-78.83 47.22-124.88 51.317l-1.951.195v-70.438h3.512v66.536c91.318-8.976 167.417-71.414 193.954-159.414.78-1.17 2.537-2.926 6.44-6.829zm8.78 18.341l12.683-12.877h50.342c-14.634 65.56-52.293 127.413-104.977 170.144-53.464 43.317-120.782 67.122-189.661 67.122C135.26 602.96.039 468.328.039 302.085.04 135.843 135.261.625 301.508.625c68.879 0 136.197 23.804 189.661 67.121 52.684 42.536 90.148 104.39 104.977 170.145H546l-12.878-12.878-.195-.39c-32-95.61-120.587-162.145-221.077-166.438v85.268h-3.512V54.478h1.951c51.318 1.756 99.904 19.122 140.685 49.95 39.806 30.244 69.465 71.22 85.27 118.439l11.122 11.121h44.489C560.829 100.331 439.07 3.747 301.703 3.747 137.407 3.747 3.747 137.404 3.747 301.695c0 164.291 133.66 297.949 297.956 297.949 137.368 0 259.126-96.78 290.15-230.242H547.56l-11.122 11.122c-15.805 47.219-45.269 88.194-85.27 118.438-40.78 30.829-89.562 48.194-140.685 49.95h-1.951v-88.974h3.512v85.267c100.49-4.097 189.272-71.219 221.077-166.633zM517.9 236.135C491.364 147.94 415.265 85.697 324.142 76.722v66.34h-3.512V72.82l1.951.195c45.854 4.098 89.172 21.854 124.88 51.317 35.318 28.878 60.684 67.121 73.952 110.438l11.123 11.122h64v3.512h-65.561l-12.879-12.878-.195-.39zm-77.855 47.024c.39 3.902.78 8.195.976 12.292l-3.512.195c-.195-4.097-.39-8.195-.976-12.097-7.61-57.95-52.684-104.975-109.855-115.706v-3.708c58.927 10.732 105.562 59.317 113.367 119.024zm29.074 10.536h132.1v3.512H467.559L454.68 284.33v-.585c-7.61-65.755-56.196-119.023-120.783-132.877l-1.366-.39V92.136l2.147.39c82.538 12.878 149.856 73.365 171.515 154.145l11.122 11.122h81.172v3.512h-82.733l-12.878-12.878-.196-.39c-20.878-78.829-86.245-138.145-166.636-151.608v51.316c65.367 14.44 114.343 68.487 122.148 135.023l10.927 10.927zm-14.44 24.976l12.879-12.878h133.66v3.512h-132.1l-10.926 10.927c-8 66.34-56.781 120.584-122.148 135.023v51.316c80.391-13.268 145.758-72.584 166.636-151.608l.196-.39 12.878-12.878h82.733v3.512h-81.172l-11.122 11.122c-21.66 80.78-88.977 141.267-171.515 154.145l-2.147.39v-58.341l1.366-.39c64.782-13.854 113.173-67.122 120.783-132.877v-.585zm16.391 11.902l12.878-12.878h116.685v3.512H485.51l-11.122 11.122c-11.902 66.926-62.05 121.56-127.807 138.926l-.975-3.513c64.586-17.17 113.758-70.633 125.27-136.584l.195-.585zM271.263 37.697l1.951-.195v105.56h-3.512V41.405C138.383 57.405 39.65 168.818 39.65 301.5c0 132.682 98.733 244.095 230.052 259.9V459.938h3.512v105.56l-1.95-.195C137.016 550.083 35.941 436.718 35.941 301.5S137.212 52.917 271.263 37.697zm300.688 178.34l-3.512 1.171C531.559 100.136 424.24 21.502 301.508 21.502c-154.344 0-279.81 125.463-279.81 279.803s125.66 279.997 280.005 279.997c121.758 0 228.881-77.853 266.345-193.754l3.317 1.17c-18.341 56.586-53.464 105.366-101.465 140.878-48.976 36.292-107.318 55.414-168.392 55.414C145.212 585.01 17.99 457.79 17.99 301.5S145.212 17.99 301.508 17.99c61.464 0 120.001 19.317 169.173 56 47.61 35.317 83.513 85.853 101.27 142.047zm-131.905 103.61c-7.805 59.51-54.05 108.29-112.782 119.218v-3.708c56.977-10.926 101.66-58.145 109.27-115.901.39-3.902.78-8 .976-11.902l3.512.195c-.195 4.097-.39 8.195-.976 12.097zm111.807-95.61C517.706 113.794 417.217 39.65 301.703 39.454h-1.561v103.413h-3.513V35.941h5.074c57.757 0 112.782 18.342 159.027 52.878 44.683 33.56 78.245 81.17 94.635 134.243l-3.512.975z",
  transform: "rotate(-90 335.5 302)",
  fill: "url(#c)"
}), React.createElement("path", {
  d: "M533.277 360.621l-5.074-1.95c1.171-2.732 2.147-5.66 3.122-8.586.976-2.927 1.952-5.854 2.927-8.585l5.073 1.56-2.926 8.781c-.976 3.122-1.952 6.049-3.122 8.78z",
  fill: "url(#D)",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  d: "M550.448 367.256l-5.074-1.952c1.171-2.926 2.342-6.048 3.317-9.17.976-3.122 2.147-6.244 3.122-9.171l5.074 1.561c-.976 3.122-1.952 6.244-3.122 9.366-.976 3.317-2.147 6.439-3.317 9.366z",
  fill: "url(#E)",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  d: "M534.252 187.355c-.975-2.927-1.756-5.854-2.927-8.586-.975-2.926-2.146-5.658-3.122-8.585l5.074-1.951c1.17 2.927 2.146 5.853 3.122 8.78l2.926 8.78-5.073 1.562z",
  fill: "url(#F)",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  d: "M35.513 187.355l-5.074-1.561 2.927-8.78c.976-2.928 2.147-5.854 3.122-8.781l5.074 1.951c-1.171 2.732-2.147 5.659-3.122 8.585-1.171 2.732-2.147 5.659-2.927 8.586z",
  fill: "url(#d)",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  d: "M36.488 360.621c-1.17-2.926-2.146-5.853-3.122-8.78-.975-2.927-1.95-5.854-2.927-8.78l5.074-1.561c.975 2.926 1.756 5.853 2.927 8.585.975 2.927 2.146 5.658 3.122 8.585l-5.074 1.951z",
  fill: "url(#e)",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  d: "M551.813 181.891c-.975-3.122-1.95-6.244-3.122-9.17-.975-3.122-2.146-6.05-3.317-9.171l5.074-1.951 3.512 9.366c1.17 3.121 2.146 6.243 3.122 9.365l-5.269 1.561z",
  fill: "url(#G)",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  d: "M.585 274.378c-.195-3.317-.195-6.634-.195-9.95 0-3.318 0-6.635.195-9.952l5.464.195c-.195 3.317-.195 6.44-.195 9.756 0 3.317 0 6.44.195 9.756l-5.464.195z",
  fill: "url(#f)",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  d: "M196.1 97.404l-2.536-4.683c1.951-.975 4.098-2.146 6.049-3.122 1.951-.975 4.097-1.95 6.049-2.926l2.146 4.878c-1.951.975-4.098 1.756-6.049 2.731-1.756 1.171-3.707 2.147-5.658 3.122z",
  fill: "url(#g)",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  d: "M419.909 258.964c0-1.561-.195-3.122-.195-4.683-.195-1.561-.195-3.122-.39-4.683l5.268-.585c.195 1.56.39 3.317.39 4.878.195 1.56.195 3.317.195 4.878l-5.268.195z",
  fill: "url(#h)",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  d: "M424.592 280.037l-5.268-.586c.195-1.56.39-3.122.39-4.682.195-1.561.195-3.122.195-4.683l5.463.195c0 1.56-.195 3.317-.195 4.878-.39 1.56-.39 3.122-.585 4.878z",
  fill: "url(#i)",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  fill: "url(#H)",
  d: "M567.033 255.647h17.561v5.463h-17.561z",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  fill: "url(#I)",
  d: "M566.448 243.744h17.561v5.463h-17.561z",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  fill: "url(#J)",
  d: "M565.472 231.842h17.561v5.463h-17.561z",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  fill: "url(#K)",
  d: "M564.106 219.745h17.561v5.463h-17.561z",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  fill: "url(#L)",
  d: "M562.155 207.842h17.561v5.463h-17.561z",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  fill: "url(#M)",
  d: "M567.033 267.744h17.561v5.463h-17.561z",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  fill: "url(#N)",
  d: "M566.448 279.647h17.561v5.463h-17.561z",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  fill: "url(#O)",
  d: "M565.472 291.744h17.561v5.463h-17.561z",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  fill: "url(#P)",
  d: "M564.106 303.646h17.561v5.463h-17.561z",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  fill: "url(#Q)",
  d: "M562.155 315.744h17.561v5.463h-17.561z",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  fill: "url(#j)",
  d: "M240.004 457.791h5.463v17.561h-5.463z",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  fill: "url(#k)",
  d: "M227.906 435.157h5.463v17.561h-5.463z",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  fill: "url(#l)",
  d: "M290.931 457.791h5.463v17.561h-5.463z",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  fill: "url(#m)",
  d: "M302.834 435.157h5.463v17.561h-5.463z",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  fill: "url(#n)",
  d: "M240.004 53.502h5.463v17.561h-5.463z",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  fill: "url(#o)",
  d: "M227.906 76.136h5.463v17.561h-5.463z",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  fill: "url(#p)",
  d: "M290.931 53.502h5.463v17.561h-5.463z",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  fill: "url(#q)",
  d: "M302.834 76.136h5.463v17.561h-5.463z",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  fill: "url(#r)",
  d: "M265.565 118.867h5.463v17.561h-5.463z",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  fill: "url(#s)",
  d: "M265.565.625h5.463v17.561h-5.463z",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  fill: "url(#t)",
  d: "M265.565 392.426h5.463v17.561h-5.463z",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  fill: "url(#u)",
  d: "M265.565 510.669h5.463v17.561h-5.463z",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  d: "M197.662 117.307l-2.732-4.683c1.756-.976 3.512-2.147 5.268-3.122 1.756-.976 3.708-1.951 5.464-2.927l2.341 4.878c-1.756.976-3.512 1.756-5.268 2.732-1.561 1.17-3.317 2.146-5.073 3.122z",
  fill: "url(#v)",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  d: "M341.469 83.941c-2.147-.585-4.293-1.366-6.244-1.951-2.147-.586-4.293-1.171-6.44-1.561l1.171-5.268c2.147.585 4.293 1.17 6.635 1.756 2.146.585 4.292 1.17 6.439 1.95l-1.561 5.074z",
  fill: "url(#w)",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  d: "M339.713 102.477c-1.952-.585-3.708-1.17-5.659-1.756-1.951-.585-3.903-1.17-5.659-1.56l1.366-5.269 5.854 1.756c1.951.586 3.902 1.17 5.854 1.951l-1.756 4.878z",
  fill: "url(#x)",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  d: "M196.1 97.404l-2.536-4.683c1.951-.975 4.098-2.146 6.049-3.122 1.951-.975 4.097-1.95 6.049-2.926l2.146 4.878c-1.951.975-4.098 1.756-6.049 2.731-1.756 1.171-3.707 2.147-5.658 3.122z",
  fill: "url(#g)",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  d: "M197.662 117.307l-2.732-4.683c1.756-.976 3.512-2.147 5.268-3.122 1.756-.976 3.708-1.951 5.464-2.927l2.341 4.878c-1.756.976-3.512 1.756-5.268 2.732-1.561 1.17-3.317 2.146-5.073 3.122z",
  fill: "url(#v)",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  d: "M341.469 83.941c-2.147-.585-4.293-1.366-6.244-1.951-2.147-.586-4.293-1.171-6.44-1.561l1.171-5.268c2.147.585 4.293 1.17 6.635 1.756 2.146.585 4.292 1.17 6.439 1.95l-1.561 5.074z",
  fill: "url(#w)",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  d: "M339.713 102.477c-1.952-.585-3.708-1.17-5.659-1.756-1.951-.585-3.903-1.17-5.659-1.56l1.366-5.269 5.854 1.756c1.951.586 3.902 1.17 5.854 1.951l-1.756 4.878z",
  fill: "url(#x)",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  d: "M205.857 441.987c-2.147-.976-4.098-1.952-6.049-2.927-1.951-.976-4.098-1.951-6.049-3.122l2.537-4.683 5.853 2.927c1.952.975 3.903 1.95 6.05 2.731l-2.342 5.074z",
  fill: "url(#y)",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  d: "M205.662 422.084c-1.756-.975-3.708-1.95-5.464-2.927-1.756-.975-3.512-1.95-5.268-3.121l2.732-4.683 5.268 2.926c1.756.976 3.512 1.952 5.268 2.732l-2.536 5.073z",
  fill: "url(#z)",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  d: "M329.956 453.499l-1.17-5.269c2.146-.585 4.292-.975 6.439-1.56 2.146-.586 4.292-1.171 6.244-1.952l1.56 5.073c-2.146.586-4.292 1.366-6.438 1.952-2.147.78-4.488 1.365-6.635 1.756z",
  fill: "url(#A)",
  transform: "rotate(-90 345.724 275.151)"
}), React.createElement("path", {
  d: "M329.761 434.962l-1.366-5.268c1.952-.585 3.903-.976 5.659-1.561 1.951-.585 3.707-1.17 5.659-1.756l1.756 5.073c-1.952.585-3.903 1.366-5.854 1.951-1.951.586-3.903 1.171-5.854 1.561z",
  fill: "url(#B)",
  transform: "rotate(-90 345.724 275.151)"
})));

var SvgCoin = function SvgCoin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 671 671",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCoin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/coin.b672aca4.svg";
export { ForwardRef as ReactComponent };